import type { CrossroadsLog } from '@/api/hooks/useIntegrationLogs'

/** Mirrors V3_LOG_CATEGORIES in the backend's app/shared_models/logs.py.
 * Note that `success` counts as V3 despite the missing suffix. */
export const V3_LOG_CATEGORIES = [
  'success',
  'mapping_v3',
  'request_v3',
  'setup_v3',
  'supply_v3',
  'system_v3',
] as const

type LogDetail = CrossroadsLog['detail']

export type V3LogDetail = Extract<
  LogDetail,
  { category: (typeof V3_LOG_CATEGORIES)[number] }
>

export type LegacyLogDetail = Exclude<LogDetail, V3LogDetail>

export function isV3Detail(detail: LogDetail): detail is V3LogDetail {
  return (V3_LOG_CATEGORIES as readonly string[]).includes(detail.category)
}

/** Display label per issue category, V3 and legacy. `success` is absent on
 * purpose -- a success detail is not an issue, so callers get null. */
export const ISSUE_CATEGORY_LABELS: Record<string, string> = {
  mapping_v3: 'Mapping Issue',
  request_v3: 'Request Issue',
  setup_v3: 'Setup Issue',
  supply_v3: 'Supply Issue',
  system_v3: 'System Issue',
  mapping: 'Mapping',
  crossroads: 'Crossroads Exception',
  system: 'S&D Exception',
  rejection: 'S&D Rejected',
  authentication: 'Authentication',
}

export function issueCategoryLabel(log?: CrossroadsLog | null): string | null {
  if (!log) return null
  return ISSUE_CATEGORY_LABELS[log.detail?.category] ?? null
}

export function issueCategoryFilterLabel(category: string): string {
  if (category === 'success') return 'No Issue'
  return ISSUE_CATEGORY_LABELS[category] ?? category
}
